import type { LucideIcon } from "lucide-react";
import { Banknote, HandCoins, HeartPulse, TrendingUp, Wallet } from "lucide-react";
import { FaixaKpis, type Kpi } from "@/components/padroes";
import { formatCents } from "@/lib/format";
import type { FolhaTotais } from "@/data/folha";

interface Props {
  totais: FolhaTotais;
  colaboradores: number;
}

/** Rótulo uppercase de 11px com o ícone à direita, como no cabeçalho da faixa. */
const Rotulo = ({ texto, icon: Icon }: { texto: string; icon: LucideIcon }) => (
  <span className="flex items-center justify-between gap-2 text-[11px] uppercase tracking-[0.05em]">
    {texto}
    <Icon className="h-[15px] w-[15px] shrink-0" />
  </span>
);

/** Desconto em vermelho com "−" na frente; zerado fica sem sinal. */
const desconto = (cents: number) => (cents === 0 ? formatCents(0) : `− ${formatCents(cents)}`);

/** Faixa de totais da competência; a última célula (líquido) fica em destaque. */
export const FolhaResumo = ({ totais, colaboradores }: Props) => {
  const itens: Kpi[] = [
    { rotulo: <Rotulo texto="Salário fixo" icon={Banknote} />, valor: formatCents(totais.salarioFixo) },
    { rotulo: <Rotulo texto="Comissões" icon={TrendingUp} />, valor: formatCents(totais.comissoes) },
    {
      rotulo: <Rotulo texto="Repasse Amil" icon={HeartPulse} />,
      valor: desconto(totais.amil),
      tom: totais.amil > 0 ? "negativo" : undefined,
    },
    {
      rotulo: <Rotulo texto="Empréstimos e descontos" icon={HandCoins} />,
      valor: desconto(totais.emprestimos),
      tom: totais.emprestimos > 0 ? "negativo" : undefined,
    },
    {
      rotulo: <Rotulo texto="Líquido a pagar" icon={Wallet} />,
      valor: formatCents(totais.liquido),
      apoio: `${colaboradores} colaborador${colaboradores === 1 ? "" : "es"}`,
      tom: "destaque",
    },
  ];

  return <FaixaKpis itens={itens} minimo={170} />;
};
